import { render } from "./index.vue?vue&type=template&id=7e6c6cdd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7e6c6cdd&scoped=true&lang=css"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/wanfei-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6c6cdd"]])

export default __exports__